import { PropertyValueSet } from "@genesys/property";

import * as KnownProperties from "../known-properties";

export function getTopLevelOverrides(
  defaultsToSet: PropertyValueSet.PropertyValueSet
): PropertyValueSet.PropertyValueSet {
  if (
    PropertyValueSet.hasProperty(KnownProperties.applicationType, defaultsToSet)
  ) {
    return PropertyValueSet.keepProperties(
      [KnownProperties.applicationType],
      defaultsToSet
    );
  }
  return PropertyValueSet.Empty;
}
